<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="上传本地文件" prop="fileUrl" >
        <p style="margin-top: -40px;padding-left: 120px;font-size: 10px">
          为确保上传内容与列表内容匹配，请先
          <a @click="importTemplate">下载实例文件</a>
        </p>
        <a-spin tip="上传中..." :spinning="uploading">
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :file-list="fileList"
            :multiple="false"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <p class="ant-upload-hint">
              点击上传
            </p>
          </a-upload-dragger>
        </a-spin>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

  </a-drawer>
</template>

<script>
import { uploadUser } from '@/api/biz/user'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

export default {
  name: 'UploadForm',
  props: {
  },
  components: {

  },
  data () {
    return {
      uploading: false,
      submitLoading: false,
      formTitle: '',
      fileList: [],
      fields: [],
      fieldIndex: null,
      // 表单参数
      form: {},
      formType: 1,
      open: false,
      name: '',
      rules: {}
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    changeFields() {
      this.$refs['fieldsForm'].openModal(this.form.id, this.fields[this.fields.length], this.fields.length)
    },
    addFields(field) {
      console.log('name========', field)
      this.fields.push(field)
    },
    editField(field, index) {
      this.fieldIndex = index
      this.$refs['fieldsForm'].openModal(this.form.id, field, index)
    },
    removeField(field, index) {
      this.fields.splice(index, 1)
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('biz/user/importTemplate', {
        ...this.form
      }, `user_template_${new Date().getTime()}.xlsx`)
    },
    /**
     * 文件上传前校验
     * @param {config.form.item} formItem 表单项
     * @param {*} fileInfo 文件详情, 见 a-upload 组件 customRequest 事件
     */
    beforeUpload(fileInfo) {
      this.fileList = [fileInfo]
      console.log(this.fileList)
      return false
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.fileList = []
      this.form = {}
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '导入'
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const { fileList } = this
          const formData = new FormData()
          formData.append('file', fileList[0])
          uploadUser(formData).then(response => {
            if (response.code == 1 || response.code == 20001) {
              this.fileList = []
              this.$message.success(response.data)
              this.open = false
              this.$emit('ok')
            }else {
              this.$message.error(response.data)
              return
            }
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  thead {
    tr {
      th {
        padding: 6px 8px;
        color: #000;
        font-weight: 500;
        text-align: left;
        background: #fafafa;
        border: 1px solid #e8e8e8;
        transition: background 0.3s ease
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 12px 8px;
        color: #000;
        text-align: left;
        background: #fff;
        border: 1px solid #e8e8e8;
        transition: background 0.3s ease;
        word-break: break-word;
        line-height: 18px;
      }
    }
  }
}
</style>
